import {BoxProps} from '@miro-site/core'
import {Box, Container, Section} from '@miro-site/core'
import React from 'react'

export interface CardGridProps extends BoxProps {
  isHighlighted?: boolean
  children: React.ReactNode
  top?: React.ReactNode
}

const defaultCard = {
  paddingLeft: 10,
  paddingRight: 10,
  width: ['50%', '33.33%'],
  marginTop: [28, 40],
}

const highlightedCard = {
  paddingLeft: 10,
  paddingRight: 10,
  width: ['100%', '50%'],
  marginTop: [32, 20],
}

const CardGrid: React.FC<CardGridProps> = ({isHighlighted, children, top, ...props}) => {
  return (
    <Section {...props}>
      <Container>
        {top && <Box>{top}</Box>}

        <Box
          $styles={{
            display: 'flex',
            marginLeft: -10,
            flexFlow: 'row wrap',
          }}
        >
          {React.Children.map(children, child => (
            <Box $styles={isHighlighted ? highlightedCard : defaultCard}>{child}</Box>
          ))}
        </Box>
      </Container>
    </Section>
  )
}

export default CardGrid
